export async function restartWithUpdate(api, backendBehind) {
  if (!api?.installUpdate) throw new Error('Desktop updating is unavailable.');
  if (backendBehind) {
    const backend = await api.restartBackend?.();
    if (!backend?.ok) throw new Error('The backend could not restart. Aria has not restarted.');
  }
  const result = await api.installUpdate();
  if (!result?.ok) throw new Error(result?.reason || 'The update could not be installed. Aria has not restarted.');
  return result;
}
